import axiosInstance from 'Utils/axiosInstance';
import { sortItems } from 'Utils/mappers';

function mapDtoToForecast(dto) {
    return {
        ...dto,
        creation_date: new Date(dto.creation_date),
        last_update: new Date(dto.last_update),
        period_start: new Date(dto.period_start),
        period_end: new Date(dto.period_end),
    };
}

export async function getForecasts() {
    const response = await axiosInstance.get('/forecasts');

    if (!response?.data) return [];

    return response.data.map(mapDtoToForecast).sort(sortItems);
}

export async function getForecastsWithOtherWorkspaces() {
    const response = await axiosInstance.get('/forecasts', {
        params: {
            include_other_workspaces: true,
        },
    });

    if (!response?.data) return [];

    return response.data.map(mapDtoToForecast).sort(sortItems);
}

export async function sortForecasts(data) {
    const response = await axiosInstance.post('/forecasts/sort', data);

    if (!response?.data) return [];

    return response.data.map(mapDtoToForecast).sort(sortItems);
}

export async function createForecast(data) {
    const response = await axiosInstance.post('/forecasts', {
        ...data,
        consolidated_matrix: false,
    });

    if (!response?.data) return null;

    return mapDtoToForecast(response.data);
}

export async function getForecast(id) {
    const response = await axiosInstance.get(`/forecasts/${id}`);

    if (!response?.data) return null;

    return mapDtoToForecast(response.data);
}

export async function deleteForecast(id) {
    await axiosInstance.delete(`/forecasts/${id}`);
}

export async function updateForecast(id, data) {
    const response = await axiosInstance.patch(`/forecasts/${id}`, data);

    if (!response?.data) return null;

    return mapDtoToForecast(response.data);
}

export async function renderForecast(id) {
    const response = await axiosInstance.get(`/forecasts/${id}/render`);
    return response?.data;
}

export async function createForecastValue(id, data) {
    const response = await axiosInstance.post(`/forecasts/${id}/values`, data);
    return response?.data;
}

export async function deleteForecastValue(forecastId, forecastValueId) {
    await axiosInstance.delete(`/forecasts/${forecastId}/values/${forecastValueId}`);
}

export async function duplicateForecast(id, data) {
    const response = await axiosInstance.post(`/forecasts/${id}/duplicate`, data);

    if (!response?.data) return null;

    return mapDtoToForecast(response.data);
}

export async function createConsolidationMatrix(data) {
    const response = await axiosInstance.post('/forecasts', {
        ...data,
        consolidated_matrix: true,
    });

    if (!response?.data) return null;

    return mapDtoToForecast(response.data);
}

const mapDtoToTransaction = (dto) => ({
    ...dto,
    date_executed: dto.date_executed ? new Date(dto.date_executed) : null,
});

export async function getForecastInspectLiquidated(forecastId, filters) {
    const response = await axiosInstance.get(`/forecasts/${forecastId}/inspect-liquidated`, {
        params: filters,
    });

    if (!response?.data) return null;

    return {
        ...response.data.transactions,
        items: response.data.transactions.items.map(mapDtoToTransaction),
    };
}

function mapRecurrenceToPending(recurrence) {
    return {
        ...recurrence,
        date_payment: null,
        integration_id: null,
        is_recurrence: true,
    };
}

function mapInvoiceToPending(invoice) {
    return {
        ...invoice,
        date_expiration: invoice.date_expiration ? new Date(invoice.date_expiration) : null,
        date_payment: invoice.date_payment ? new Date(invoice.date_payment) : null,
    };
}

export async function getForecastInspectPending(forecastId, filters) {
    const response = await axiosInstance.get(`/forecasts/${forecastId}/inspect-pending`, {
        params: filters,
    });

    if (!response?.data) return null;

    const recurrences = response.data.recurrences.map(mapRecurrenceToPending);
    const invoices = response.data.invoices.items.map(mapInvoiceToPending);

    return {
        ...response.data.invoices,
        invoices: invoices,
        recurrences: recurrences,
    };
}

export async function getForecastInspectValue(forecastId, filters) {
    const response = await axiosInstance.get(`/forecasts/${forecastId}/inspect-values`, {
        params: filters,
    });

    if (!response?.data) return null;

    return response.data;
}
